import { BUSINESS_TYPE } from '../utils/constants';

const businessTypeMapper = (siteName) => {
    let businessTypes;
    switch (siteName) {
        case 'abritel' :
            businessTypes = {
                SA: 'Société anonyme (SA)',
                SASU: 'Société par actions simplifiée unipersonnelle (SASU)',
                SAS: 'Société par action simplifié (SAS)',
                SARL: 'Société à responsabilité limité (SARL)',
                EURL: 'Entreprise unipersonelle à responsabilité limitée (EURL)',
                PO: 'Propriétaire Particulier'
            };
            break;
        case 'homeaway_de' :
            businessTypes = {
                AG: 'Aktiengesellschaft (AG)',
                GMBH: 'Gesellschaft mit beschränkter Haftung (GmbH)',
                COKG: 'Kommanditgesellschaft (CO KG)',
                PO: 'Privatvermieter'
            };
            break;
        case 'homeaway_pt' :
            businessTypes = {
                LDA: 'Sociedade de quoteas (LDA)',
                SA: 'Sociedade anónima (SA)',
                PO: 'Propietário privado'
            };
            break;
        case 'homeaway_es' :
            businessTypes = {
                SA: 'Sociedad Anónima (SA)',
                SL: 'Sociedad Limitada (SL)',
                SLL: 'Sociedad Limitada Laboral (SLL)',
                SC: 'Sociedad Colectiva (SC)',
                SCA: 'Sociedad Comanditaria Acciones (SCA)',
                PO: 'Propietario particular'
            };
            break;
        case 'homeaway_it' :
            businessTypes = {
                SPA: 'Società per azioni (S.p.a.)',
                SRL: 'Società a responsabilità limitata (S.r.l.)',
                SAPA: 'Società in accomandita per azioni (s.a.p.a)',
                SC: 'Sociedad Colectiva (SC)',
                SRLS: 'Società a responsabilità limitata semplificata (s.r.l.s)',
                PO: 'Proprietario'
            };
            break;
        case 'homeaway_uk' :
            businessTypes = {
                PLC: 'Public limited company',
                PVTLC: 'Private limited company',
                PO: 'Private Owner'
            };
            break;
        case 'homeaway_au' :
        case 'homeaway_nz' :
            businessTypes = {
                PLC: BUSINESS_TYPE.PLC,
                PVTLC: BUSINESS_TYPE.PVTLC
            };
            break;
        default:
            businessTypes = {};
            break;
    }

    return businessTypes;
};

export default businessTypeMapper;
